import { Avatar, Button, Modal, Select, Tag, notification, Space } from "antd";
import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Link, useLocation } from "react-router-dom";
import { siteInfo } from "../utils/SiteInfo";
import {
  CloudServerOutlined,
  GoldOutlined,
  HomeOutlined,
  TeamOutlined,
  UsergroupAddOutlined,
  SafetyCertificateOutlined,
} from "@ant-design/icons";
import { IoCashOutline } from "react-icons/io5";
import { setProfile } from "../reducers/authReducer";
import { isPermitted } from "../utils/PermissionManager";

export default function Navbar(props) {
  const profile = useSelector((state) => state.auth?.profile);
  const auth = useSelector((state) => state.auth);
  const config = useSelector((state) => state.config?.config);
  const location = useLocation();
  const dispatch = useDispatch();

  const [roleModalOpen, setRoleModalOpen] = useState(false);
  const [selectedRoles, setSelectedRoles] = useState([]);

  useEffect(() => {
    if (profile?.roles?.includes("master_admin")) {
      localStorage.setItem("is_master_admin", "true");
    } else {
      localStorage.removeItem("is_master_admin");
    }
  }, [profile]);

  const isMasterAdmin =
    profile?.roles?.includes("master_admin") ||
    localStorage.getItem("is_master_admin") === "true";

  const handleOpenRoleModal = () => {
    setSelectedRoles(profile?.roles || []);
    setRoleModalOpen(true);
  };

  const handleApplyRoles = () => {
    // if not master admin return
    if (!isPermitted(profile?.roles, ["master_admin"])) {
      return false;
    }

    const updatedProfile = {
      ...profile,
      roles: selectedRoles,
    };
    dispatch(setProfile(updatedProfile));

    if (localStorage.config) {
      try {
        let localConfig = JSON.parse(localStorage.config);
        localConfig.profile = updatedProfile;
        localStorage.setItem("config", JSON.stringify(localConfig));
      } catch (e) {
        console.log(e);
      }
    }

    notification.success({
      message: "Roles Updated",
      description: `Active roles set to: ${
        selectedRoles.length > 0 ? selectedRoles.join(", ") : "None"
      }`,
    });

    setRoleModalOpen(false);
  };

  let routes = [
    {
      path: "/",
      title: "Dashboard",
      icon: HomeOutlined,
    },
    {
      path: "/purchasing",
      title: "Purchasing",
      icon: CloudServerOutlined,
    },
    {
      path: "/orders",
      title: "Orders",
      icon: GoldOutlined,
    },
    {
      path: "/customers",
      title: "Customers",
      icon: TeamOutlined,
    },
    {
      path: "/payments",
      title: "Payments",
      icon: IoCashOutline,
    },
    {
      path: "/admins",
      title: "Admins",
      icon: UsergroupAddOutlined,
    },
    {
      path: "/settings/admin-otp",
      title: "Admin OTP",
      icon: SafetyCertificateOutlined,
    },
  ];

  const getRouteName = (pathname) => {
    let found = routes.find((el) => el.path === pathname);
    if (found) {
      return (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <found.icon size={18} color="#fff" />
          <span
            style={{
              color: "#fff",
              marginLeft: 8,
              textTransform: "capitalize",
            }}
          >
            {found.title}
          </span>
        </div>
      );
    } else {
      let arr = pathname.split("/");
      let name = arr[arr.length - 1];

      console.log(name);

      name =
        name && typeof name === "string" ? name?.split("-").join(" ") : name;

      if (pathname.includes("/create-post")) {
        name = "Create Post";
      }
      if (pathname.includes("/edit-post")) {
        name = "Edit Post";
      }
      if (pathname.includes("/delivery/")) {
        name = "Invoice";
      }
      if (pathname.includes("/cash-counter/")) {
        name = "Cash Counter";
      }
      if (pathname.includes("/campaign/")) {
        name = "Campaign Details";
      }
      if (pathname.includes("agent/orders")) {
        name = "Agent Orders";
      }
      if (pathname.includes("/agent/withdraw/")) {
        name = "Agent Withdraw";
      }

      if (pathname.includes("/skyexpress-bookings")) {
        name = "SkyExpress Bookings";
      }
      if (pathname.includes("/crm/customer")) {
        name = "Customer Details";
      }

      if (pathname === "/purchasing") {
        name = "Air Purchase";
      }

      if (pathname.includes("/shipping-categories")) {
        name = "Shipping Categories";
      }

      if (pathname.includes("/my-crm")) {
        name = "My CRM";
        if (pathname.length > 10) {
          name = "Manager CRM";
        }
      }
      if (pathname.includes("/bulk-order-carton-list")) {
        name = "Bulk Order Carton List";
      }
      if (pathname.includes("/gallery/")) {
        name = "Image Gallery";
      }
      if (pathname.includes("/tasks/")) {
        name = "Tasks Details";
      }
      if (pathname.includes("/chat/")) {
        name = "Chat";
      }
      if (pathname.includes("/manage-product")) {
        name = "Manage Product";
      }
      if (pathname.includes("/manage-group-deal")) {
        name = "Manage Group Deal";
      }
      if (pathname.includes("/group-deal/")) {
        name = "Group Deal Details";
      }
      if (pathname.includes("/bill-of-entries/edit/")) {
        name = "Edit Bill Of Entry";
      }
      if (pathname.includes("/bill-of-entries/create")) {
        name = "Bill Of Entry";
      }
      if (pathname.includes("/mushak/")) {
        name = "Mushak";
      }

      return (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <span style={{ color: "#fff", textTransform: "capitalize" }}>
            {name}
          </span>
        </div>
      );
    }
  };

  return (
    <>
      {location.pathname !== "/login" && (
        <nav
          style={{
            backgroundColor: siteInfo.navColor,
            padding: "0px 1.5rem",
            position: "fixed",
            boxShadow: "0 1px 16px rgba(0,0,0,.1)",
            borderBottom: "1px solid rgba(0,0,0,0.08)",
            zIndex: 11,
            height: "60px",
            color: "white",
            top: 0,
            left: 200,
            right: 0,
            display: auth?.isAuthenticated ? "block" : "none",
          }}
        >
          <div
            style={{
              display: "flex",
              alignItems: "center",
              height: "100%",
              justifyContent: "space-between",
            }}
          >
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              {getRouteName(location.pathname)}
            </div>
            <div style={{ display: "flex", alignItems: "center" }}>
              {isMasterAdmin && (
                <Button
                  type="primary"
                  icon={<SafetyCertificateOutlined />}
                  onClick={handleOpenRoleModal}
                ></Button>
              )}
              <Link to="/profile" className="logout">
                <div
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    alignItems: "center",
                  }}
                >
                  <Avatar
                    style={{ backgroundColor: "#fde3cf", color: "#f56a00" }}
                  >
                    U
                  </Avatar>
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "flex-start",
                      marginLeft: "0.5rem",
                    }}
                  >
                    <span
                      style={{
                        lineHeight: "18px",
                        fontWeight: "bold",
                        color: "#f0f0f0",
                      }}
                    >
                      {profile?.name ? profile?.name : "Administration"}
                    </span>
                    <span
                      style={{
                        lineHeight: "18px",
                        fontWeight: "bold",
                        color: "#eee",
                        fontSize: 12,
                      }}
                    >
                      {profile?.phone || ""}
                    </span>
                  </div>
                </div>
              </Link>
            </div>
          </div>
        </nav>
      )}

      {/* Role Simulator / Access Checker Modal */}
      <Modal
        title="Access Checker (Test Role Permissions)"
        open={roleModalOpen}
        onCancel={() => setRoleModalOpen(false)}
        onOk={handleApplyRoles}
        okText="Apply Roles"
        cancelText="Cancel"
        width={600}
      >
        <div style={{ marginBottom: 16 }}>
          <p style={{ marginBottom: 8, fontWeight: 600 }}>Quick Presets:</p>
          <Space wrap>
            <Tag
              color="gold"
              style={{ cursor: "pointer", fontWeight: "bold" }}
              onClick={() =>
                setSelectedRoles(["master_admin", "super_admin", "admin"])
              }
            >
              Master Admin
            </Tag>
            <Tag
              color="blue"
              style={{ cursor: "pointer" }}
              onClick={() => setSelectedRoles(["admin", "cnf"])}
            >
              Admin & CNF
            </Tag>
            <Tag
              color="purple"
              style={{ cursor: "pointer" }}
              onClick={() => setSelectedRoles(["admin"])}
            >
              Admin Only
            </Tag>
            <Tag
              color="orange"
              style={{ cursor: "pointer" }}
              onClick={() => setSelectedRoles(["cnf"])}
            >
              CNF Only
            </Tag>
            <Tag
              color="green"
              style={{ cursor: "pointer" }}
              onClick={() => setSelectedRoles(["accountant"])}
            >
              Accountant
            </Tag>
            <Tag
              color="magenta"
              style={{ cursor: "pointer" }}
              onClick={() => setSelectedRoles(["china_crm", "china_admin"])}
            >
              China CRM
            </Tag>
            <Tag
              color="red"
              style={{ cursor: "pointer" }}
              onClick={() => setSelectedRoles([])}
            >
              Clear All
            </Tag>
          </Space>
        </div>

        <div style={{ marginBottom: 16 }}>
          <p style={{ marginBottom: 8, fontWeight: 600 }}>
            Select Active Roles:
          </p>
          <Select
            mode="multiple"
            style={{ width: "100%" }}
            placeholder="Select roles to simulate..."
            value={selectedRoles}
            onChange={(values) => setSelectedRoles(values)}
            allowClear
          >
            {config &&
              config.admin_roles?.map((role) => (
                <Select.Option key={role} value={role}>
                  {role}
                </Select.Option>
              ))}
          </Select>
        </div>
      </Modal>
    </>
  );
}
